import React, { useEffect, useState } from 'react';
import { db } from '../../firebaseConfig';
import {
  collection,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import './ManageClinics.css';

const ManageClinicVisits = () => {
  const { t } = useTranslation();
  const [visits, setVisits] = useState([]);
  const [clinics, setClinics] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    fetchVisits();
    fetchClinics();
  }, []);

  const fetchClinics = async () => {
    const snapshot = await getDocs(collection(db, 'clinics'));
    const result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setClinics(result);
  };

  const fetchVisits = async () => {
    const visitSnapshot = await getDocs(collection(db, 'clinic_visits'));
    const allVisits = visitSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    const customerSnapshot = await getDocs(collection(db, 'customers'));
    const customersMap = {};
    customerSnapshot.docs.forEach(doc => {
      customersMap[doc.data().token] = doc.data().name;
    });

    const enriched = allVisits.map(visit => ({
      ...visit,
      customer_name: customersMap[visit.customer_token] || 'Unknown',
      visited_date: visit.visited_at?.toDate?.().toISOString().split('T')[0] || '',
    }));

    setVisits(enriched);
  };

  const filteredVisits = visits.filter(v => {
    const matchClinic = !selectedClinic || v.clinic_id === selectedClinic;
    const date = new Date(v.visited_date);
    const matchStart = !startDate || date >= new Date(startDate);
    const matchEnd = !endDate || date <= new Date(endDate);
    return matchClinic && matchStart && matchEnd;
  });

  const exportToCSV = () => {
    const headers = ['Customer Name', 'Customer Token', 'Clinic Name', 'Confirmed By', 'Date'];
    const rows = filteredVisits.map(v => [v.customer_name, v.customer_token, v.clinic_name, v.confirmed_by_email, v.visited_date]);
    const csv = [headers, ...rows].map(r => r.map(cell => `"${cell}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'clinic_visits.csv';
    link.click();
  };

  return (
    <div className="manage-clinics-container">
      <h2 className="manage-clinics-title">{t('clinicVisits.title')}</h2>

      <div className="form-grid">
        <select onChange={e => setSelectedClinic(e.target.value)} value={selectedClinic}>
          <option value="">{t('clinicVisits.allClinics')}</option>
          {clinics.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>

        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />

        <button onClick={exportToCSV} className="clinic-action-btn export-btn">
          {t('clinicVisits.exportCsv')}
        </button>
      </div>

      <div className="clinic-list">
        {filteredVisits.map((v, idx) => (
          <div key={idx} className="clinic-card">
            <div className="clinic-card-info">
              <p><strong>{v.customer_name}</strong> ({v.customer_token})</p>
              <p>{v.clinic_name} - {v.visited_date}</p>
              <p>{t('clinicVisits.confirmedBy')}: {v.confirmed_by_email}</p>
            </div>
          </div>
        ))}
        {!filteredVisits.length && <p>{t('clinicVisits.noResults')}</p>}
      </div>
    </div>
  );
};

export default ManageClinicVisits;
